import { Album } from '../types';

/**
 * Demo books data - these are added to the API results for demonstration purposes
 * This allows for easy addition of more demo books in the future
 */
export const demoBooks: Album[] = [
];

export default demoBooks;
